import type { FillView, Platform } from './types';
import { consoleModeLabel } from '../fill';
import { PLATFORM_LABEL } from './adapter';

/**
 * Bitrate row of a destination card (docs/bitrate-fill.md §4), for users with
 * bitrate fill on: the mode, and while live the actual bitrate and the filler
 * in it. Facts only, in neutral colours: whether the output is fine is the
 * badge's job (state_reason / health), never this row's. One line, fixed
 * height, so cards in a grid row stay level.
 */
export function FillRow({ id, fill, platform, live }: { id: number; fill: FillView; platform: Platform; live: boolean }) {
  // The editor's full wording goes into the title; the row keeps a short one so the numbers fit a 250 px card.
  const label = fill.mode ? consoleModeLabel(fill.mode, PLATFORM_LABEL[platform]) : 'Default bitrate';
  const quality = fill.mode === 'floor' && fill.quality ? ` · ${fill.quality === 'auto' ? 'Auto' : fill.quality}` : '';
  const short = fill.mode === 'floor' ? 'Fill' : label;
  const numbers = live && fill.totalMbps !== undefined;
  const title = [
    `Bitrate for this platform: ${label}${quality}.`,
    numbers ? `Going out: ${fill.totalMbps!.toFixed(1)} Mbps, of it filler ${fill.addedMbps!.toFixed(1)} Mbps.` : '',
    fill.suspended ? 'Fill is paused while the platform reads slowly; it comes back by itself.' : '',
    'Fill adds outgoing traffic.',
  ].filter(Boolean).join(' ');
  return (
    <div
      data-testid={`dest-fill-${id}`}
      data-mode={fill.mode ?? ''}
      data-suspended={!!fill.suspended}
      title={title}
      className="tabular flex h-5 min-w-0 items-center gap-2 whitespace-nowrap font-mono text-[11px] text-muted"
    >
      <span data-testid={`dest-fill-mode-${id}`} className="min-w-0 truncate text-text-soft">{short}{quality}</span>
      <span className="ml-auto flex-none" data-testid={`dest-fill-numbers-${id}`}>
        {!numbers ? '' : fill.suspended ? 'fill paused' : fill.addedMbps ? `+${fill.addedMbps.toFixed(1)} fill · ${fill.share ?? 0}%` : 'no fill added'}
      </span>
    </div>
  );
}
